// extracted by mini-css-extract-plugin
module.exports = {"btn-create-role":"_3DiKrEalKKSYl8AnqjqqIc","disabled":"xLDwX1LFUj1AjdOkxOjdB","popover":"_15S2ydhf6WybKhvgULiorn"};